import StyledTableHead from 'Components/StyledTableHead'
import type { NetaxeptRecurringPaymentEventShape } from 'Services/SalesManagement/Features/Order/orderSlice'
import { datetimeFormatter } from 'Util/formatters'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import type { FC } from 'react'
import { t } from 'ttag'

const NetaxeptRecurringPaymentEvents: FC<{
  events: NetaxeptRecurringPaymentEventShape[]
}> = ({ events }) => {
  return (
    <>
      {events.map(event => (
        <TableRow key={event.transaction_id}>
          <TableCell>{datetimeFormatter(event.created)}</TableCell>
          <TableCell>{event.transaction_id}</TableCell>
          <TableCell>{event.status}</TableCell>
        </TableRow>
      ))}
    </>
  )
}

const NetaxeptRecurringPaymentInfo: FC<{
  events: NetaxeptRecurringPaymentEventShape[]
}> = ({ events }) => {
  return (
    <>
      <StyledTableHead>
        <TableRow>
          <TableCell colSpan={3}>{t`Payment info (Netaxept recurring)`}</TableCell>
        </TableRow>
      </StyledTableHead>
      <TableHead>
        <TableRow>
          <TableCell>{t`Created`}</TableCell>
          <TableCell>{t`Transaction ID`}</TableCell>
          <TableCell>{t`Status`}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {events.length > 0 ? (
          <NetaxeptRecurringPaymentEvents events={events} />
        ) : (
          <TableRow>
            <TableCell>{t`No payment events available`}</TableCell>
          </TableRow>
        )}
      </TableBody>
    </>
  )
}

export { NetaxeptRecurringPaymentInfo }
